<template>
	<span v-if="typeof value === 'string'">{{ value }}</span>
	<span v-else-if="html" class="[&>p]:inline" v-html="html"></span>
</template>

<script setup lang="ts">
import type { StoryblokRichTextDocumentNode } from "@storyblok/vue";
import { sanitizeHtml } from "~/layers/base/utils/html";

interface Props {
	/** A Storyblok Text field, or a Richtext field in the same slot. */
	value?: string | StoryblokRichTextDocumentNode;
}
const { value } = defineProps<Props>();

// Inline whitelist: this renders label-sized copy, never block markup.
const html = computed(() =>
	value && typeof value !== "string"
		? sanitizeHtml(renderRichText(value), {
				allowedTags: ["a", "b", "strong", "i", "em", "br", "span", "p"]
			})
		: ""
);
</script>
